import React, { useEffect, useState } from "react";
import { SelectDevices } from "./SelectDevices";
import { getGyroscope } from "../../../services/data/gyroscope";

const TITLE = "Gyroscope sensors";

export const GYROSCOPE_ID = "gyroscope";
export const DEVICE_ORIENTATION_ID = "deviceOrientation";

const GyroscopeDevicesData = [
  {
    id: DEVICE_ORIENTATION_ID,
    label: "Device orientation",
  },
];

const SelectGyroscopeDevices = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  const [data, setData] = useState(GyroscopeDevicesData);

  useEffect(() => {
    loadingDevices.add(1);
    const gyroscope = getGyroscope();
    if (gyroscope) {
      // Add gyroscope if supported.
      GyroscopeDevicesData.push({
        id: GYROSCOPE_ID,
        label: "Gyroscope",
      });
    }
    setData(GyroscopeDevicesData);
    onChange(GyroscopeDevicesData);
    loadingDevices.done();
  }, []);

  return (
    <SelectDevices
      title={TITLE}
      data={data}
      selectedDevices={selectedDevices}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default SelectGyroscopeDevices;
